import * as React from 'react';
import { Field } from 'formik';
import {
  WizardSubmitButton,
  WizardPreviousButton
} from 'buyside/components/presentation/Form/Wizard/Wizard';
import PageHeader from '../../Helpers/pageHeader';
import PageFooter from '../../Helpers/PageFooter';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
const { retailUserInvestorTypes } = require('buyside/util/constantsFromRails.json');
import { AllFormikProps } from 'interfaces/userApplication/userApplication';
import EmployerAutocomplete from 'buyside/components/presentation/EmployerAutocomplete/EmployerAutocomplete';
import RecaptchaFailed from '../../Helpers/RecaptchaFailed';
import { allocatorDisclaimer } from '../../Helpers/userApplicationPageConstants';

import styles from '../pageStyles.scss';

type PickedFormikProps = Pick<AllFormikProps, 'setFieldValue' | 'setFieldError' | 'values'>;

interface BITPType extends PickedFormikProps {
  isLoading: boolean;
  isRobot: boolean;
}

const BasicInvestorTypePage: React.FunctionComponent<BITPType> = ({
  setFieldValue,
  setFieldError,
  isLoading,
  isRobot,
  values
}): React.ReactElement => {
  return (
    <>
      <PageHeader subHeader="What type of professional are you?" />
      <div className={styles.inputForm}>
        <div className={styles.inputField} data-heap="application-basic-investor-type">
          <Field
            component={InputField}
            label="Investor Type"
            name="basicInvestorType"
            options={retailUserInvestorTypes}
            type="select"
          />
        </div>
        <label className={styles.checkboxes} data-heap="application-basic-is-accredited">
          <Field
            name="isAccredited"
            type="checkbox"
            checked={values?.isAccredited}
            disabled={isLoading}
          />
          {allocatorDisclaimer}
        </label>
        <div className={styles.inputField}>
          <EmployerAutocomplete
            analyticsTag="application-basic-employer"
            label="Employer"
            name="basicEmployerName"
            placeholder="Begin Typing..."
            setFieldValue={setFieldValue}
            setFieldError={setFieldError}
          />
        </div>
      </div>
      <WizardPreviousButton />
      <WizardSubmitButton
        submitText="Continue"
        analyticsTag="application-continue-basic-investor-type"
        isLoading={isLoading}
      />
      {isRobot && <RecaptchaFailed />}
      <PageFooter />
    </>
  );
};

export default BasicInvestorTypePage;
